import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ProfileImageService} from "../../lib/services/profile-image/profile-image.service";
import {NgxImageCompressService} from "ngx-image-compress";
import {LoadedImage} from "ngx-image-cropper";
import {ToastService} from "../../lib/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";
import {UserUtilsService} from "../../lib/services/user/user-utils.service";
import {PubsubEnum} from "../../lib/enums/pubsub.enum";
import * as pubsub from "pubsub-js"

@Component({
    selector: 'app-profile-image',
    templateUrl: './profile-image.component.html',
    styleUrls: ['./profile-image.component.scss']
})

export class ProfileImageComponent implements OnInit, AfterViewInit {
    cropper;
    stepChangeImageOptions = {
        CHANGE_IMAGE: 'CHANGE_IMAGE',
        UPLOAD_IMAGE: 'UPLOAD_IMAGE',
        CROP_IMAGE: 'CROP_IMAGE'
    }
    stepChangeImage = this.stepChangeImageOptions.CHANGE_IMAGE;
    selectedFile!: File | null;
    imageUrl: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    dragOver!: boolean;
    translateMessages;
    loading = false;
    userInfo: any;

    constructor(private profileImageService: ProfileImageService,
                private imageCompress: NgxImageCompressService,
                private toastService: ToastService,
                private translateService: TranslateService,
                private userUtilsService: UserUtilsService) {
    }

    ngOnInit(): void {
        this.userInfo = this.userUtilsService.getUserInfoSessionStorage();
        this.translateService.get('changeProfilePhoto').subscribe(messages => {
            this.translateMessages = messages;
        })
    }

    closeDialog() {
        this.profileImageService.closeModal();
    }


    cropImage() {
        this.compressAndResizeImage(this.croppedImage)
    }

    uploadImageStep() {
        this.stepChangeImage = this.stepChangeImageOptions.UPLOAD_IMAGE;
    }

    uploadedFiles: any[] = [];

    onUpload(event: any) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }

    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            const file = files[0];
            if (allowedTypes.includes(file.type)) {
                this.selectedFile = file;
                this.fileToImageSrc();
            } else {
                console.error('Invalid file type. Please drop a PNG, JPEG, or JPG file.');
                this.toastService.showToast(this.translateMessages.errors.typeImage, 'warn')
            }
        } else {
            console.log('Error')
        }
    }

    onDragOver(event: DragEvent) {
        this.dragOver = true
        event.preventDefault();
    }

    ngAfterViewInit(): void {
    }

    onFileSelected(event: any): void {
        this.selectedFile = event.target.files[0];
        this.fileToImageSrc();
    }

    fileToImageSrc() {
        if (this.selectedFile) {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.imageUrl = e.target.result;
            };
            reader.readAsDataURL(this.selectedFile);
            this.stepChangeImage = this.stepChangeImageOptions.CROP_IMAGE;
        }
    }


    imageCropped(event: any) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.croppedImage = e.target.result;
        };
        reader.readAsDataURL(event.blob);
    }

    imageLoaded(image: LoadedImage) {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    compressAndResizeImage(imageToBase64: any) {
        this.imageCompress
            .compressFile(imageToBase64, -1, 80, 80, 80, 80) // -1 for auto quality, 80px x 80px dimensions
            .then((result) => {
                const base64 = result.replace('data:image/png;base64,', '')
                this.updateProfileImage(result);
            });
    }

    backBtn() {
        this.stepChangeImage = this.stepChangeImageOptions.UPLOAD_IMAGE;
    }

    updateProfileImage(imageAsBase64) {
        this.loading = true;
        imageAsBase64 = imageAsBase64.replace('data:image/png;base64,', '')
        const payload = {imagenAvatar: imageAsBase64, mimeType: 'image/png'}
        this.profileImageService.updatePhoto(payload).subscribe({
            next: response => {
                if (response && response?.code == '-1') {
                    this.toastService.showToast(this.translateMessages.errors.errorService)
                } else {
                    pubsub.publish(PubsubEnum.CHANGE_PROFILE_IMAGE);
                    this.userUtilsService.setUserInfoSessionStorage({userImage: 'data:image/png;base64,' + imageAsBase64})
                    this.profileImageService.closeModal();
                    this.toastService.showToast(this.translateMessages.successMessage, 'success', '');
                }
                this.loading = false;
            },
            error: err => {
                this.loading = false;
                this.toastService.showToast(this.translateMessages.errors.errorService)
            }
        })
    }

    calculateInitials() {
        return this.userUtilsService.calculateInitials();
    }
}
